// extracted by mini-css-extract-plugin
export var cardBody = "resource-module--cardBody--1bcf3";
export var resourceCard = "resource-module--resourceCard--d4368";
export var resourceCardButton = "resource-module--resourceCardButton--c4c42";
export var resourceType = "resource-module--resourceType--52506";
export var resourceTypeSpecific = "resource-module--resourceTypeSpecific--f0a18";